export default __webpack_public_path__ + "static/media/phone-icon.2b0d0be4.svg";